/**
 * Utilitaires SEO — Show Événement
 */

export const SITE = 'https://show-evenement.com';

/**
 * Génère les métadonnées SEO pour une fiche produit
 */
export function getProductSEO(product) {
  if (!product) return {};

  const nom = product.nom || 'Matériel événementiel';
  const cat = product.categorie_nom || 'Location';
  const prix = product.tarifs?.particulier;
  const slug = product.slug || product.id;

  const title = `${nom} — Location à Figeac, Lot (46)`;
  const description = product.seo_description
    || product.description_longue
    || `Location ${nom.toLowerCase()} à Figeac et dans le Lot (46). ${prix ? `À partir de ${prix}€.` : ''} Livraison dans tout le Lot, Aveyron, Cantal. Devis gratuit, installation comprise.`;

  const canonical = `${SITE}/produit/${slug}`;
  const image = product.images?.[0] || `${SITE}/og-image.jpg`;

  // Schema Product (schema.org)
  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: nom,
    description: description,
    image: product.images || [],
    brand: { '@type': 'Brand', name: 'Show Événement' },
    category: cat,
    url: canonical,
    ...(prix ? {
      offers: {
        '@type': 'Offer',
        price: prix,
        priceCurrency: 'EUR',
        priceValidUntil: new Date(Date.now() + 365*24*60*60*1000).toISOString().slice(0,10),
        availability: product.disponible !== false
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
        seller: { '@type': 'Organization', name: 'Show Événement' },
        areaServed: 'Figeac, Lot (46), Aveyron, Cantal',
        priceSpecification: {
          '@type': 'PriceSpecification',
          price: prix,
          priceCurrency: 'EUR',
          description: `À partir de ${prix}€ / journée`,
        },
      }
    } : {}),
    ...(product.featured ? { additionalProperty: [{
      '@type': 'PropertyValue',
      name: 'Bestseller',
      value: true,
    }]} : {}),
  };

  return { title, description, canonical, image, schema: productSchema };
}

/**
 * Génère le slug depuis un nom (cohérent avec le backend)
 */
export function makeSlug(nom) {
  if (!nom) return '';
  return 'location-' +
    nom.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') +
    '-figeac';
}

/**
 * Pages statiques du site avec leurs métadonnées SEO
 */
export const STATIC_PAGES_SEO = {
  '/': {
    title: 'Location matériel événementiel — Figeac, Lot (46)',
    description: 'Spécialiste location animations événementielles à Figeac. Photobooth, jeux gonflables, machine barbe à papa, mobilier. Livraison Lot (46), Aveyron, Cantal. Devis gratuit.',
  },
  '/catalogue': {
    title: 'Catalogue location animations — Figeac, Lot (46)',
    description: 'Catalogue complet : location photobooth, jeux gonflables, animations gourmandes, mobilier événementiel. Livraison et installation. Devis gratuit. Figeac, Lot (46).',
  },
  '/creer-evenement': {
    title: 'Créer mon événement — Configurateur en ligne',
    description: 'Configurez votre événement en 2 minutes. Choisissez vos animations, obtenez un devis instantané. Location matériel Figeac, Lot (46).',
  },
  '/contact': {
    title: 'Contact — Show Événement Figeac',
    description: 'Contactez Show Événement à Figeac pour votre projet événementiel. Devis gratuit, réponse rapide. Location animations Lot (46).',
  },
  '/zones': {
    title: 'Zones de livraison — Figeac et Lot (46)',
    description: 'Nos zones de livraison : Figeac, Lot (46), Aveyron (12), Cantal (15), Corrèze (19). Livraison gratuite à 20 km autour de Figeac.',
  },
  '/partenaires': {
    title: 'Partenaires événementiels — Figeac, Lot',
    description: 'Prestataires événementiels recommandés dans le Lot (46) et alentours. Traiteurs, photographes, salles de réception.',
  },
};
